import { KeycloakConfig } from 'keycloak-js';

/**
 * Config used for test, override in production
 */
const hardcodedConfig: KeycloakConfig = {
  url: 'https://minikube/auth',
  realm: 'nuada',
  clientId: 'quinoa-client',
};

export const loadKeycloakConfig = async (signal?: AbortSignal): Promise<KeycloakConfig> => {

  signal?.throwIfAborted();
  
  try {
    const response = await fetch('/config/keycloak-config.json', { signal });

    if (!response.ok) {
      throw new Error(`Config fetch failed with status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    // If we deliberately aborted, don't show a warning
    if (error instanceof Error && error.name === 'AbortError') {
      throw error;
    }

    console.warn('Using hardcoded Keycloak config fallback:', error);
    return hardcodedConfig;
  }
};
